export default "__VITE_ASSET__e0288abe__"